import React from 'react'
import { connect } from 'react-redux'
import { compose } from 'recompose'
import './styles.css'
import withDrawer from '../../components/withDrawer'
import MenuIcon from '@material-ui/icons/Menu'
import {
  Button,
  Typography,
  Card,
  TextField,
  CardContent
} from '@material-ui/core'
import Horizontal_Logo from '../../assets/images/sselogo1(nobackwhite).png'
import MoreVert from '@material-ui/icons/MoreVert'
import FormControl from '@material-ui/core/FormControl'
import Input from '@material-ui/core/Input'
import InputLabel from '@material-ui/core/InputLabel'
import CardActions from '@material-ui/core/CardActions'
import CircularProgress from '@material-ui/core/CircularProgress'
import {
  checkUserByPhone
  // confirmUser,
  // ocrUpload
} from '../../actions/users'
import { updateExsistingEvent } from '../../actions/events'
// import { geocodeByPlaceId, getLatLng } from 'react-places-autocomplete'
import MyMapComponent from '../../components/MyMapComponent'
// import { openSnackBar } from '../../actions/snack-bar'
import {
  getAddress
  // addShowingAttendee
} from '../../actions/users'
import { TextMaskCustom } from '../../components/MaskedInput'
import moment from 'moment'
import ShowImage from '../../components/ShowImage'

// import cloudinary from 'cloudinary'
// import cloudinary from 'cloudinary'

const google = window.google

const mapsStaticURL = 'https://maps.googleapis.com/maps/api/staticmap?'

//TODO can not submit without phone
//TODO NOTES update
class ShowingsDone extends React.Component {
  state = {
    safetyName: '',
    safetyTitle: '',
    selectedFile: null,
    data: {
      phone: '',
      firstName: '',
      lastName: '',
      title: '',
      address: '',
      id: ''
    },
    address: '',
    addressParts: {},
    lat: '',
    lng: '',
    center: '',
    zoom: 13,
    size: '400x200',
    valueAddress: '',
    foundClientUser: false,
    endTimeFormatted: '',
    logEvent: {},
    logAddress: '',
    notes: ''
  }

  handlePlacesChange = () => {
    this.setState({ valueAddress: this.state.valueAddress })
  }

  componentDidMount() {
    if (google && google.maps) {
      let autocomplete = new google.maps.places.Autocomplete(
        document.getElementById('autocomplete'),
        {
          types: ['geocode']
        }
      )
      this.geolocate()

      autocomplete.addListener('place_changed', () => {
        let place = autocomplete.getPlace()
        let location =
          place.geometry && place.geometry.location
            ? place.geometry.location
            : null
        let latitude = location ? location.lat() : null
        let longitude = location ? location.lng() : null
        if (latitude == null || longitude == null) {
          return false
        }
      })
    }

    if (this.props.value) {
      this.handlePlacesChange(this.props.value)
    }

    let events = this.props.authentication.authenticatedUser.events

    const indexEvent = events.findIndex(x => {
      return x.id === +this.props.match.params.id
    })

    if (indexEvent !== -1) {
      if (
        this.props.authentication.authenticatedUser.events &&
        this.props.authentication.authenticatedUser.events[indexEvent]
      ) {
        let newState
        try {
          newState = this.props.authentication.authenticatedUser.events[
            indexEvent
          ].attendees[0]
        } catch (err) {}

        let logEvent = this.props.authentication.authenticatedUser.events[
          indexEvent
        ]

        const { city, state, route, street_number, zip } = logEvent
        let logAddress = `${street_number !== null ? street_number : ''} ${route !== null ? route : ''}
         ${city !== null ? city : ''}, ${state !== null ? state : ''} ${zip !== null ? zip : ''}`
        let endTime = this.props.authentication.authenticatedUser.events[
          indexEvent
        ].end_time

        const end_timeMoment = moment.utc(endTime).local().format('YYYY-MM-DD h:mm:ss a')
        const endTimeFormatted = end_timeMoment
        const notes = logEvent.notes || ''

        const data = this.state.data
        if (newState) {
          data.phone = newState.phone.substring(2)
        }
        this.setState({
          data,
          endTimeFormatted,
          logEvent,
          logAddress,
          notes
        })

        this.props.dispatch(checkUserByPhone(data.phone)).then(res => {
          let data = this.state.data
          data.firstName = res.first_name
          data.lastName = res.last_name
          data.id = res.id

          this.setState({
            data: data,
            foundClientUser: true
          })
        })
      }
    }
  }

  doCheck = () => {
    this.setState({
      checkingNumber: true
    })

    this.props
      .dispatch(checkUserByPhone(this.state.data.phone))
      .then(() => {
        this.setState({ foundClientUser: true })
      })
      .catch(err => {
        if (err.status === 404) {
          // this.createUser();
          this.setState({
            checkingNumber: false
          })
        }
      })
  }

  geolocate() {
    console.log('navigator')
    // if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(position => {
        this.props.dispatch(
          getAddress(
            position.coords.latitude,
            position.coords.longitude,
            this.handleOnChange
          )
        )
        this.setState({
          lat: position.coords.latitude,
          lng: position.coords.longitude,
          mapURL: `${mapsStaticURL}center=${position.coords.latitude},${
            position.coords.longitude
          }&zoom=${this.state.zoom}&size=${this.state.size}`
        })
      },
      err =>
      this.setState({
        lat: this.props.location.state.lat,
        lng: this.props.location.state.lng,
        mapURL: `${mapsStaticURL}center=${this.props.location.state.lat},${
          this.props.location.state.lng
        }&zoom=${this.state.zoom}&size=${this.state.size}`
      })
        )
    // }
  }

  geocodeLatLng(geocoder, map, infowindow) {
    var input = document.getElementById('latlng').value
    var latlngStr = input.split(',', 2)
    var latlng = {
      lat: parseFloat(latlngStr[0]),
      lng: parseFloat(latlngStr[1])
    }
    geocoder.geocode({ location: latlng }, function(results, status) {
      if (status === 'OK') {
        if (results[0]) {
          map.setZoom(11)
          var marker = new google.maps.Marker({
            position: latlng,
            map: map
          })
          infowindow.setContent(results[0].formatted_address)
          infowindow.open(map, marker)
        } else {
          window.alert('No results found')
        }
      } else {
        window.alert('Geocoder failed due to: ' + status)
      }
    })
  }

  handleOnChange = (e, obj) => {
    if (obj) {
      this.setState({
        address: e,
        addressParts: obj
      })
    } else {
      this.setState({
        address: e.target.value
      })
    }
  }

  handleUpdate = () => {
    const { id: eventId } = this.props.match.params
    const { addressParts, notes, data } = this.state
    const { id: attendeeId } = data

    this.props.dispatch(
      updateExsistingEvent(addressParts, attendeeId, eventId, notes)
    )
    this.props.history.push('/showings')
  }

  changePhoto = (photo_id) => {
    return typeof photo_id === 'string' &&
      photo_id.length > 0 &&
      JSON.parse(photo_id) &&
      JSON.parse(photo_id).public_id
        ? JSON.parse(photo_id).public_id
        : ''
  }

  render() {
    const { history, toggleDrawer, authentication } = this.props
    const { data, endTimeFormatted } = this.state
    const { firstName, lastName } = data
    const { events } = authentication.authenticatedUser
    // const { photo_id } = authenticatedUser

    const indexEvent = events.findIndex(x => {
      return x.id === +this.props.match.params.id
    })

    let photo_id

    if (
      this.props.authentication.authenticatedUser &&
      this.props.authentication.authenticatedUser.events &&
      this.props.authentication.authenticatedUser.events[indexEvent] &&
      this.props.authentication.authenticatedUser.events[indexEvent]
        .attendees[0]
    ) {
      photo_id =
        this.props.authentication.authenticatedUser.events[indexEvent]
          .attendees[0].photo_id || ''
    }

    const attendeeLength = events[indexEvent].attendees.length
    const event = events[indexEvent]

    // const photoID =
    //   typeof photo_id === 'string' &&
    //   photo_id.length > 0 &&
    //   JSON.parse(photo_id) &&
    //   JSON.parse(photo_id).public_id
    //     ? JSON.parse(photo_id).public_id
    //     : ''
        console.log(events[indexEvent], 'events')
    return (
      <div className="showings-detail-app">
        <div className="showings-detail-header-done">
          <MenuIcon
            className="showings-detail-menu"
            onClick={() => toggleDrawer()}
          />
          <img
            src={Horizontal_Logo}
            className="showings-detail-logo"
            alt="logo"
          />
          <MoreVert
            className="showings-detail-menu"
            alt="MoreVert"
            style={{ visibility: 'hidden' }}
          />
        </div>

        <div style={{ overflow: 'scroll' }}>
          <div className="showings-detail-license">
            {/* CARDS MAP AND CONTACT DETAILS */}

            <Typography variant="h5" color="primary">{`${
              attendeeLength === 1
                ? `${firstName !== null ? firstName : ''} ${lastName !== null ? lastName : ''}`
                : attendeeLength > 1
                ? 'Multiple clients'
                : 'No Client'
            }`}</Typography>
            <Typography>{`${endTimeFormatted}`}</Typography>

            <div
              style={{
                borderTop: '1px solid',
                paddingTop: '12px',
                borderColor: '#cecbcb'
              }}
            />

            {/* MAP */}
            <div className="showings-detail-cards">
              <Card className="map-cardWrapper">
                <div
                  className="map-headerBox"
                  style={{
                    minHeigh: '100px',
                    minWidth: '90vw'
                  }}
                >
                  {this.state.lat && this.state.lng ? (
                    <MyMapComponent
                      isMarkerShown
                      lat={this.state.lat}
                      lng={this.state.lng}
                      zoom={this.state.zoom}
                    />
                  ) : (
                    <div
                      style={{
                        marginTop: '16px'
                      }}
                    >
                      <CircularProgress />
                    </div>
                  )}
                </div>
                {/* Map */}
                <CardActions className="map-footerBox">
                  <div className="map-footerBox">
                    <FormControl fullWidth>
                      <InputLabel htmlFor="currentLocation">Address</InputLabel>
                      <Input
                        type="text"
                        name="currentLocation"
                        id="autocomplete"
                        value={this.state.logAddress}
                        onChange={this.handleOnChange}
                        fullWidth
                        disabled
                        // defaultValue={logAddress}
                      />
                    </FormControl>
                  </div>
                </CardActions>
              </Card>

              {event.attendees.map(x => (
                <React.Fragment key={x.id}>
                  <Card className="client-card-app">
                    <div className="client-card-body">
                      <form
                        className="client-card-form"
                        id="register-form"
                        noValidate
                        autoComplete="off"
                      >
                        <div className="client-card-names-wrapper">
                          <FormControl
                            style={{
                              margin: '10px 0px 0px 0px'
                            }}
                            fullWidth
                          >
                            <InputLabel htmlFor="loginPhone">
                              Client Phone
                            </InputLabel>
                            <Input
                              name="loginPhone"
                              id="loginPhone"
                              type="tel"
                              disabled
                              inputComponent={TextMaskCustom}
                              value={x.phone.replace('+1', '')}
                            />
                          </FormControl>
                        </div>

                        <div className="client-card-names-wrapper">
                          <FormControl
                            style={{
                              margin: '10px 20px 0px 0px'
                            }}
                          >
                            <InputLabel htmlFor="registerFirstName">
                              First Name
                            </InputLabel>
                            <Input
                              name="registerFirstName"
                              value={x.first_name}
                              id="registerFirstName"
                              autoComplete="nope"
                              disabled
                            />
                          </FormControl>

                          <FormControl
                            style={{
                              margin: '10px 0px 0px 0px'
                            }}
                          >
                            <InputLabel htmlFor="registerLastName">
                              Last Name
                            </InputLabel>
                            <Input
                              name="registerLastName"
                              value={x.last_name}
                              id="registerLastName"
                              autoComplete="nope"
                              disabled
                            />
                          </FormControl>
                        </div>
                      </form>
                    </div>
                      <CardContent>
                        <ShowImage
                          publicID={this.changePhoto(x.photo_id)}
                          crop="fill"
                          gravity="face"
                          width="200"
                          height="200"
                        />
                      </CardContent>
                  </Card>
                </React.Fragment>
              ))}

              <Card
                style={{
                  marginTop: '10px'
                }}
              >
                <TextField
                  id="standard-multiline-static"
                  label="Notes"
                  multiline
                  rows="6"
                  value={this.state.notes}
                  onChange={e => {
                    this.setState({ notes: e.target.value })
                  }}
                  style={{
                    marginLeft: '16px',
                    marginRight: '16px',
                    width: '83vw',
                    marginTop: '8px'
                  }}
                  className="standard-multiline-static"
                  margin="normal"
                />
              </Card>
              <div className="showings-done-buttons-wrapper">
                <div className="showings-done-buttons">
                  <Button
                    color="primary"
                    onClick={() => history.push('/showings')}
                  >
                    CANCEL
                  </Button>
                  <Button
                    variant="contained"
                    className="client-card-footerButton"
                    color="primary"
                    onClick={() => this.handleUpdate()}
                    // onClick={() => history.push('/showings')}
                  >
                    UPDATE
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = store => {
  return {
    authentication: store.authentication,
    profile: store.profile,
    pics: store.pics
  }
}
const mapActionsToProps = dispatch => {
  return {
    toggleDrawer: () => dispatch({ type: 'DRAWER_TOGGLED', payload: true }),
    dispatch
  }
}

export default withDrawer(
  compose(
    connect(
      mapStateToProps,
      mapActionsToProps
    )
  )(ShowingsDone)
)
